import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zogwarfysatzgljyvqqx.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpvZ3dhcmZ5c2F0emdsanl2cXF4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3MTcyMDMsImV4cCI6MjA4MDI5MzIwM30.Vacqd2QsFMcsXq3g3BqiqHwJZlNLeeFq76QtGgWF79k';

const customSupabaseClient = createClient(supabaseUrl, supabaseAnonKey);

export default customSupabaseClient;

export { 
    customSupabaseClient,
    customSupabaseClient as supabase,
};
